import React from 'react';
import { useStore } from '../hooks/useStore';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
import { DoorStrip, DOOR_PALETTE, WOOD_TEXTURE_CSS } from '../components/DoorStrip';
export function VacantesPage() {
  const {
    vacantes
  } = useStore();
  return <div className="min-h-screen bg-white" data-id="element-736">
      {/* ── HERO HEADER ── */}
      <div className="relative bg-black overflow-hidden pt-24 pb-12 px-6 text-center" data-id="element-737">
        <div className="relative z-10" data-id="element-738">
          <img src="https://cdn.magicpatterns.com/uploads/ewfDCj5QKNDNeQRsTcwjBG/logo_de_Junquito_Gas_(4).ai_(4).png" alt="La Cochera" className="h-12 mx-auto mb-6" data-id="element-739" />
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-white tracking-tight mb-6" data-id="element-740">
            Únete al Equipo
          </h1>
          <div className="flex justify-center gap-1 mb-0" data-id="element-741">
            {DOOR_PALETTE.map((c, i) => <div key={i} className="w-8 h-1 rounded-full" style={{
            backgroundColor: c
          }} data-id="element-742" />)}
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0" data-id="element-743">
          <DoorStrip height="h-2" data-id="element-744" />
        </div>
      </div>

      {/* ── SECTION BANNER ── */}
      <div className="relative overflow-hidden" style={{
      backgroundColor: DOOR_PALETTE[4],
      backgroundImage: WOOD_TEXTURE_CSS
    }} data-id="element-745">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between" data-id="element-746">
          <div data-id="element-747">
            <h2 className="font-display text-3xl font-extrabold text-white tracking-tight" data-id="element-748">
              Oportunidades
            </h2>
            <p className="text-white/70 text-xs font-bold uppercase tracking-widest pl-1" data-id="element-749">
              Crece con nosotros
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-16 space-y-8" data-id="element-750">
        {vacantes.map((v, idx) => <div key={v.id} className="group relative bg-white rounded-xl overflow-hidden border border-stone-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-751">
            {/* Left accent bar */}
            <div className="absolute left-0 top-0 bottom-0 w-1.5 z-10" style={{
          backgroundColor: DOOR_PALETTE[idx % DOOR_PALETTE.length]
        }} data-id="element-752" />

            <div className="p-8 pl-10 flex flex-col md:flex-row gap-8" data-id="element-753">
              <div className="flex-1" data-id="element-754">
                <div className="flex items-center gap-4 mb-4" data-id="element-755">
                  <h2 className="font-display text-2xl font-bold text-stone-900" data-id="element-756">
                    {v.title}
                  </h2>
                  <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${v.type === 'tiempo-completo' ? 'bg-black text-white' : 'bg-stone-100 text-stone-600'}`} data-id="element-757">
                    {v.type.replace('-', ' ')}
                  </span>
                </div>
                <p className="text-stone-500 mb-8 leading-relaxed font-medium" data-id="element-758">
                  {v.description}
                </p>
                <button className="px-6 py-3 bg-black text-white rounded-xl font-bold text-sm hover:bg-stone-800 transition-colors flex items-center gap-2" data-id="element-759">
                  Aplicar Ahora <ArrowRightIcon className="w-4 h-4" data-id="element-760" />
                </button>
              </div>

              <div className="md:w-72 bg-stone-50 rounded-xl p-6 border border-stone-100" data-id="element-761">
                <h3 className="text-xs font-bold uppercase text-stone-400 mb-4 tracking-widest" data-id="element-762">
                  Requisitos
                </h3>
                <ul className="space-y-3" data-id="element-763">
                  {v.requirements.map((r, i) => <li key={i} className="flex items-start gap-3 text-sm text-stone-600 font-medium" data-id="element-764">
                      <CheckCircleIcon className="w-4 h-4 text-black flex-shrink-0 mt-0.5" data-id="element-765" />
                      {r}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}